import { Avatar, Badge, Box, Button, CircularProgress, Modal } from "@mui/material";
import React, { useEffect, useState } from "react";
import ClientProfilTab from "./ClientProfilTab";
import ClientProfileHeaderModern from "./ClientProfileHeaderModern";
import CheckRibon from "./CheckRibon";
import InformationRibon from "./InformationRibon";
import MainAddictionRibon from "./MainAddictionRibon";
import SearchBar from "./SearchBar";
import StatusRibon from "./StatusRibon";
import { db, storage } from "../firebase";
import { deleteDoc, doc, onSnapshot, updateDoc } from "firebase/firestore";
import rehabs, { getRehabByClient } from "../api/rehabs";
import { incrementDailyReads } from "../logsComponents/incrementDailyReads";
import AddClientInClient from "./forms/AddClientInClient";
import { format } from "date-fns";
import { readAndCompressImage } from "browser-image-resizer";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import DropDownComponent from "./DropDownComponent";
import DropDownComponentSorted from "./DropDownComponentSorted";
import { IconButton } from "@mui/joy";
import { Edit as EditIcon } from "@mui/icons-material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";

export default function ClientProfile(props) {
  const [isAllPreadmissionFieldsFilled, setIsAllPreadmissionFieldsFilled] =
    useState(false);
  const navigate = useNavigate();
  const imageConfig = {
    quality: 0.9,
    maxWidth: 200,
    autoRotate: true,
    debug: true,
  };

  const styleModalGeneral = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 750,
    height: 600,
    borderRadius: 5,
    // overflowY: "scroll",

    /*border: "1px solid #000",*/
    boxShadow: 24,
  };

  const handleBackClick = () => {
    const clientRehab = getRehabByClient(clientData || {});
    const clientListPath =
      clientRehab?.country === "Philippines" ? "/clients?rehab=ph" : "/clients";

    navigate(clientListPath, {
      state: { selectedTab: clientData.clientStatus },
    });
  };

  const [, setUploadingImage] = useState(false);
  const [openAddClient, setOpenAddClient] = useState(false);
  const [openStatusModal, setOpenStatusModal] = useState(false);
  const [isLoadingUpdateStatus, setIsLoadingUpdateStatus] = useState(false);
  const [openPrimaryAddictionModal, setOpenPrimaryAddictionModal] =
    useState(false);
  const [isLoadingUpdateAddiction, setIsLoadingUpdateAddiction] =
    useState(false);

  const [clientData, setClientData] = useState(null);
  const [newClientStatus, setNewClientStatus] = useState("");
  const [newClientAddiction, setNewClientAddiction] = useState("");
  const [openModal, setOpenModal] = React.useState(false);
  const [openModalPhoto] = React.useState(false);
  const [clientDataPreAdmission, setClientDataPreAdmission] = useState({});
  const handleCloseAddClient = () => setOpenAddClient(false);

  const handleOpenModalPhoto = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleCloseModalPhoto = () => {
    setOpenModal(false);
  };

  const handleOpenAddictionModal = () => {
    setOpenPrimaryAddictionModal(true);
  };

  const handleCloseAddictionModal = () => {
    setOpenPrimaryAddictionModal(false);
  };

  const handleOpenStatusModal = () => {
    setOpenStatusModal(true);
  };

  const handleCloseStatusModal = () => {
    setOpenStatusModal(false);
  };

  const handleClientStatusChange = (newValue) => {
    setNewClientStatus(newValue);
  };

  const handleClientAddictionChange = (newValue) => {
    setNewClientAddiction(newValue);
  };

  const handleUpdateClientStatus = async () => {
    setIsLoadingUpdateStatus(true);
    const clientRef = doc(db, "clients", props.clientId);

    // Vérifier si le statut change de 'In House' à un autre statut
    if (
      clientData.clientStatus === "In House" &&
      newClientStatus !== "In House"
    ) {
      // Vérifier si le client a un numéro de chambre assigné
      if (clientData.roomNumber) {
        const roomDocRef = doc(db, "RoomNumbers", clientData.roomNumber);
        await deleteDoc(roomDocRef); // Supprimer l'entrée de la chambre
        // Ne pas modifier le champ 'roomNumber' du client
      }
    }

    // Mettre à jour le statut du client
    await updateDoc(clientRef, { clientStatus: newClientStatus });

    setIsLoadingUpdateStatus(false);
    handleCloseStatusModal();
  };

  const handleUpdatePrimaryAddiction = async () => {
    setIsLoadingUpdateAddiction(true);
    const clientRef = doc(db, "clients", props.clientId);
    await updateDoc(clientRef, { primaryAddiction: newClientAddiction });
    setIsLoadingUpdateAddiction(false);
    handleCloseAddictionModal();
  };

  const handleUpdateRehab = async (event) => {
    const nextRehab = rehabs.find((rehab) => rehab.id === event.target.value);
    if (!nextRehab || !props.clientId) return;

    const rehabUpdate = {
      rehabId: nextRehab.id,
      rehabName: nextRehab.name,
      rehabCountry: nextRehab.country,
      rehabLocation: nextRehab.location,
      rehabTimezone: nextRehab.timezone,
      rehabCurrency: nextRehab.currency,
    };

    await updateDoc(doc(db, "clients", props.clientId), rehabUpdate);
    setClientData((previousClientData) => ({
      ...previousClientData,
      ...rehabUpdate,
    }));
  };

  useEffect(() => {
    if (!clientData) return;

    const fieldValues = {
      nationality: clientData.nationality,
      maritalStatus: clientData.maritalStatus,
      primaryAddiction: clientData.primaryAddiction,
      secondaryAddiction: clientData.secondaryAddiction,
      passportStatus: clientDataPreAdmission.passportStatus,
      // suicidePlan: clientDataPreAdmission.suicidePlan,
      currentLivingArrangements:
        clientDataPreAdmission.currentLivingArrangements,
      dietaryRequirements: clientDataPreAdmission.dietaryRequirements,
      fundingSource: clientDataPreAdmission.fundingSource,
      currentWithdrawalSymptoms:
        clientDataPreAdmission.currentWithdrawalSymptoms,
      processAddictions: clientDataPreAdmission.processAddictions,
      addictionTreatmentHistory:
        clientDataPreAdmission.addictionTreatmentHistory,
      treatmentGoals: clientDataPreAdmission.treatmentGoals,
      barriersForRehab: clientDataPreAdmission.barriersForRehab,
      motivationForTreatment: clientDataPreAdmission.motivationForTreatment,
      currentMentalHealthIssues:
        clientDataPreAdmission.currentMentalHealthIssues,
      traumaHistory: clientDataPreAdmission.traumaHistory,
      currentProvider: clientDataPreAdmission.currentProvider,
      historyOfSeizures: clientDataPreAdmission.historyOfSeizures,
      currentMedications: clientDataPreAdmission.currentMedications,
      currentPastInjury: clientDataPreAdmission.currentPastInjury,
      currentMedicalIllness: clientDataPreAdmission.currentMedicalIllness,
      allergies: clientDataPreAdmission.allergies,
      legalProblems: clientDataPreAdmission.legalProblems,
      therapistPreference: clientDataPreAdmission.therapistPreference,
      discoverMiraclesAsia: clientDataPreAdmission.discoverMiraclesAsia,
      eatingDisorderDiagnosis: clientDataPreAdmission.eatingDisorderDiagnosis,
      eatingDisorderFoodConsumption:
        clientDataPreAdmission.eatingDisorderFoodConsumption,
      eatingDisorderVomitingLaxatives:
        clientDataPreAdmission.eatingDisorderVomitingLaxatives,
      traumaTreatment: clientDataPreAdmission.traumaTreatment,
      mentalHealthTreatment: clientDataPreAdmission.mentalHealthTreatment,
      selfHarmType: clientDataPreAdmission.selfHarmType,
      unwantedConsequencesOfAddiction:
        clientDataPreAdmission.unwantedConsequencesOfAddiction,
      reasonForSeekingTreatment:
        clientDataPreAdmission.reasonForSeekingTreatment,
      substanceAddiction: clientDataPreAdmission.substanceAddiction,
      childrenOrDependents: clientDataPreAdmission.childrenOrDependents,
      mentalHealthDiagnosis: clientDataPreAdmission.mentalHealthDiagnosis,
      bipolarWithPsychoticFeatures:
        clientDataPreAdmission.bipolarWithPsychoticFeatures,
      hallucinations: clientDataPreAdmission.hallucinations,
      delusionalThinking: clientDataPreAdmission.delusionalThinking,
      suicidalThoughts: clientDataPreAdmission.suicidalThoughts,
      historyOfSuicideAttempts: clientDataPreAdmission.historyOfSuicideAttempts,
      passportCopy: clientDataPreAdmission.passportCopy,
      flightDetails: clientDataPreAdmission.flightDetails,
      flightDetailsContent: clientDataPreAdmission.flightDetailsContent,
      vipTransfer: clientDataPreAdmission.vipTransfer,
      paymentDetails: clientDataPreAdmission.paymentDetails,
    };

    // Fonction pour enregistrer les champs non remplis
    const logUnfilledFields = (fields, name) => {
      const unfilled = Object.entries(fields)
        .filter(([key, value]) => value === undefined || value === "")
        .map(([key]) => key);
      if (unfilled.length > 0) {
        console.log(`${name} - Unfilled fields:`, unfilled.join(", "));
      } else {
        console.log(`${name} - All fields are filled.`);
      }
    };

    logUnfilledFields(fieldValues, "Field Values");

    const checkApplyFields = {
      bipolar12: clientDataPreAdmission.bipolar12,
      previousPersonalityDisorder:
        clientDataPreAdmission.previousPersonalityDisorder,
      activePsychosis: clientDataPreAdmission.activePsychosis,
      diagnosisWithPsychoticFeatures:
        clientDataPreAdmission.diagnosisWithPsychoticFeatures,
      recentSelfHarm: clientDataPreAdmission.recentSelfHarm,
      violentBehavior: clientDataPreAdmission.violentBehavior,
      historyOfSeizure: clientDataPreAdmission.historyOfSeizure,
      activeFoodRestriction: clientDataPreAdmission.activeFoodRestriction,
      currentMobilityIssues: clientDataPreAdmission.currentMobilityIssues,
      currentComplexMedicalIssues:
        clientDataPreAdmission.currentComplexMedicalIssues,
      suicidalIdeation: clientDataPreAdmission.suicidalIdeation,
      suicideAttempt: clientDataPreAdmission.suicideAttempt,
      noneApply: clientDataPreAdmission.noneApply,
    };

    logUnfilledFields(checkApplyFields, "Check Apply Fields");

    const areFieldValuesFilled = Object.values(fieldValues).every(
      (value) => value !== undefined && value !== null && value !== ""
    );
    console.log("areFieldValuesFilled:", areFieldValuesFilled);

    const isAtLeastOneCheckApplyFieldFilled = Object.values(
      checkApplyFields
    ).some((v) => v);

    console.log(
      "isAtLeastOneCheckApplyFieldFilled:",
      isAtLeastOneCheckApplyFieldFilled
    );

    const areAllConditionsMet =
      areFieldValuesFilled && isAtLeastOneCheckApplyFieldFilled;
    console.log("areallConditionsmet:", areAllConditionsMet);

    setIsAllPreadmissionFieldsFilled(areAllConditionsMet);
  }, [clientData, clientDataPreAdmission]);

  console.log("isAllPreAdmissionFieldsFilled:", isAllPreadmissionFieldsFilled);

  function formatDate(timestamp) {
    if (!timestamp || !timestamp.seconds) return "";

    const milliseconds =
      timestamp.seconds * 1000 + timestamp.nanoseconds / 1000000;
    const date = new Date(milliseconds);

    if (isNaN(date)) return "";

    return format(date, "d MMMM yyyy"); // "d" pour le jour, "MMMM" pour le mois en texte, "yyyy" pour l'année
  }

  const handleProfilePictureChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      try {
        const resizedImage = await readAndCompressImage(file, imageConfig);
        setUploadingImage(true);
        const storageRef = ref(storage, `profilePics/${clientData.id}`);
        await uploadBytes(storageRef, resizedImage);
        const profilePictureURL = await getDownloadURL(storageRef);
        await updateDoc(doc(db, "clients", clientData.id), {
          profilePicture: profilePictureURL,
        });
        setUploadingImage(false);
      } catch (error) {
        console.error("Error resizing and uploading image:", error);
        setUploadingImage(false);
      }
    }
  };

  useEffect(() => {
    // Récupération des données client de base
    const clientRef = doc(db, "clients", props.clientId);
    const unsubscribeClient = onSnapshot(clientRef, (snapshot) => {
      if (snapshot.exists()) {
        setClientData({ id: snapshot.id, ...snapshot.data() });
        try { incrementDailyReads("profile_client_doc", 1); } catch {}
      } else {
        console.log("No such document in clients!");
      }
    });

    return () => {
      unsubscribeClient();
    };
  }, [props.clientId]);

  useEffect(() => {
    // Récupération des données d'évaluation pré-admission
    const preAdmissionRef = doc(db, "preAdmissionAssessments", props.clientId);
    const unsubscribePreAdmission = onSnapshot(preAdmissionRef, (snapshot) => {
      if (snapshot.exists()) {
        setClientDataPreAdmission({ id: snapshot.id, ...snapshot.data() });
        try { incrementDailyReads("profile_preadmission_doc", 1); } catch {}
      } else {
        console.log("No such document in preAdmissionAssessments!");
      }
    });

    return () => {
      unsubscribePreAdmission();
    };
  }, [props.clientId]);
  // console.log("Both data set :", clientData, clientDataPreAdmission);

  useEffect(() => {
    if (clientData) {
      setNewClientStatus(clientData.clientStatus);
      setNewClientAddiction(clientData.primaryAddiction);
    }
  }, [clientData]);

  if (!clientData) {
    return (
      <div className="client-profil-sub-container">
        <CircularProgress />
      </div>
    );
  }

  return (
    <div className="client-profil-sub-container">
      <Modal
        open={openAddClient}
        onClose={handleCloseAddClient}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModalGeneral}>
          <AddClientInClient closemodal={handleCloseAddClient} />
        </Box>
      </Modal>

      <Modal
        open={false}
        onClose={handleCloseStatusModal}
        aria-labelledby="status-modal-title"
        aria-describedby="status-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 300,
            height: 220,
            borderRadius: 5,
            backgroundColor: "white",
            boxShadow: 24,
          }}
        >
          <div className="status-modal-title">Change Client Status</div>
          <div className="container-small-modal">
            <DropDownComponentSorted
              api="clientStatus"
              value={newClientStatus}
              onChange={handleClientStatusChange}
              title="Client Status"
              displayInHouseAsActive={
                clientData.rehabId === "miracles_asia_philippines" ||
                clientData.rehabCountry === "Philippines"
              }
            />
            <div style={{ display: "flex", flexDirection: "row" }}>
              <Button
                variant="contained"
                style={{
                  backgroundColor: "white",
                  color: "black",
                  marginRight: 10,
                }}
                onClick={handleCloseStatusModal}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handleUpdateClientStatus}
                disabled={isLoadingUpdateStatus}
              >
                {isLoadingUpdateStatus ? "Updating..." : "Update"}
              </Button>
            </div>
          </div>
        </Box>
      </Modal>

      <Modal
        open={false}
        onClose={handleCloseAddictionModal}
        aria-labelledby="status-modal-title"
        aria-describedby="status-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 300,
            height: 220,
            borderRadius: 5,
            backgroundColor: "white",
            boxShadow: 24,
          }}
        >
          <div className="status-modal-title">Change Primary Addiction</div>
          <div className="container-small-modal">
            <DropDownComponent
              api="addictions"
              value={newClientAddiction}
              onChange={handleClientAddictionChange}
              title="Primary Addiction"
            />
            <div style={{ display: "flex", flexDirection: "row" }}>
              <Button
                variant="contained"
                style={{
                  backgroundColor: "white",
                  color: "black",
                  marginRight: 10,
                }}
                onClick={handleCloseAddictionModal}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handleUpdatePrimaryAddiction}
                disabled={isLoadingUpdateAddiction}
              >
                {isLoadingUpdateAddiction ? "Updating..." : "Update"}
              </Button>
            </div>
          </div>
        </Box>
      </Modal>

      <Modal
        open={openModalPhoto}
        onClose={handleCloseModalPhoto}
        aria-labelledby="modal-image"
        aria-describedby="image-full-size"
      >
        <div
          onClick={handleCloseModalPhoto}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "100%",
            position: "absolute",
            top: 0,
            left: 0,
            backgroundColor: "rgba(0, 0, 0, 0.3)",
          }}
        >
          <img
            src={props.profilePic}
            alt="Full-size profile"
            style={{
              maxWidth: "90%",
              maxHeight: "90%",
              objectFit: "contain",
            }}
          />
        </div>
      </Modal>

      <div className="top-component-list-client">
        <ClientProfileHeaderModern
          clientData={clientData}
          formatDate={formatDate}
          handleBackClick={handleBackClick}
          handleOpenModalPhoto={handleOpenModalPhoto}
          handleProfilePictureChange={handleProfilePictureChange}
          handleOpenStatusModal={handleOpenStatusModal}
          handleOpenAddictionModal={handleOpenAddictionModal}
          isAllPreadmissionFieldsFilled={isAllPreadmissionFieldsFilled}
          openStatusModal={openStatusModal}
          openPrimaryAddictionModal={openPrimaryAddictionModal}
          newClientStatus={newClientStatus}
          newClientAddiction={newClientAddiction}
          handleClientStatusChange={handleClientStatusChange}
          handleClientAddictionChange={handleClientAddictionChange}
          handleCloseStatusModal={handleCloseStatusModal}
          handleCloseAddictionModal={handleCloseAddictionModal}
          handleUpdateClientStatus={handleUpdateClientStatus}
          handleUpdatePrimaryAddiction={handleUpdatePrimaryAddiction}
          isLoadingUpdateStatus={isLoadingUpdateStatus}
          isLoadingUpdateAddiction={isLoadingUpdateAddiction}
          rehabs={rehabs}
          selectedRehab={getRehabByClient(clientData)}
          handleUpdateRehab={handleUpdateRehab}
        />
        <div className="line1-title-client-profile legacy-client-profile-summary">
          <div className="line1-sub-client-profile">
            <div className="block1">
              <div className="profile-client-pic-container">
                <Badge
                  overlap="circular"
                  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  badgeContent={
                    <IconButton
                      aria-label="upload picture"
                      component="span"
                      style={{
                        backgroundColor: "#1565c0",
                        color: "white",
                        width: "20px",
                        height: "20px",
                        borderRadius: "50%",
                        padding: "0px",
                      }} // Changez la couleur d'arrière-plan au besoin
                      onClick={() =>
                        document.getElementById("contained-button-file").click()
                      }
                    >
                      <EditIcon style={{ fontSize: "20px" }} />
                    </IconButton>
                  }
                >
                  <IconButton
                    onClick={handleBackClick}
                    style={{ marginRight: "8px" }}
                  >
                    <ArrowBackIcon />
                  </IconButton>
                  <div
                    style={{ cursor: "pointer" }}
                    onClick={handleOpenModalPhoto}
                  >
                    <Avatar
                      src={clientData.profilePicture}
                      style={{
                        width: "72px",
                        height: "72px",
                      }}
                    />
                  </div>
                </Badge>
                <input
                  accept="image/*"
                  id="contained-button-file"
                  multiple
                  type="file"
                  style={{ display: "none" }}
                  onChange={handleProfilePictureChange}
                />
              </div>
              <div className="profile-client-name-container">
                <div className="profile-client-name">
                  {clientData.firstName} {clientData.lastName}{" "}
                  {clientData.age && clientData.age !== "NA"
                    ? ` - ${clientData.age} years old`
                    : ""}{" "}
                  {clientData.gender && clientData.gender !== "NA"
                    ? ` - ${clientData.gender}`
                    : ""}
                  {/* {clientData.firstName} {clientData.lastName} -{" "}
                  {clientData.age} years old - {clientData.gender}{" "} */}
                </div>
                <div className="profile-client-subtext">
                  {clientData.selectedTherapist
                    ? `Assigned therapist: ${clientData.selectedTherapist}`
                    : "No therapist assigned yet"}
                  {clientData.clientIdentifier ? (
                    <span>
                      {" - Client identifier: "}
                      <span style={{ fontWeight: 400 }}>
                        {clientData.clientIdentifier}
                      </span>
                    </span>
                  ) : (
                    "No client identifier"
                  )}
                </div>
              </div>
            </div>
            <div className="block2">
              <div className="search-area-client">
                <SearchBar />
              </div>
              <div className="client-profil-add-client-button"></div>
            </div>
          </div>
        </div>

        <div className="line2-title-client-profile legacy-client-profile-summary" style={{ gap: "10px" }}>
          <div className="profile-inline-editable">
            <StatusRibon
              status={clientData.clientStatus}
              rehabId={clientData.rehabId}
              rehabCountry={clientData.rehabCountry}
              onClick={handleOpenStatusModal}
              isAllPreadmissionFieldsFilled={isAllPreadmissionFieldsFilled}
            />
            {openStatusModal && (
              <div className="profile-inline-editor">
                <span className="profile-inline-editor-kicker">Status</span>
                <DropDownComponentSorted
                  api="clientStatus"
                  value={newClientStatus}
                  onChange={handleClientStatusChange}
                  title="Client status"
                  displayInHouseAsActive={
                    clientData.rehabId === "miracles_asia_philippines" ||
                    clientData.rehabCountry === "Philippines"
                  }
                />
                <div className="profile-inline-editor-actions">
                  <Button size="small" onClick={handleCloseStatusModal}>Cancel</Button>
                  <Button size="small" variant="contained" onClick={handleUpdateClientStatus} disabled={isLoadingUpdateStatus}>
                    {isLoadingUpdateStatus ? "Updating..." : "Save"}
                  </Button>
                </div>
              </div>
            )}
          </div>

          {/* <StatusRibon status={clientData.clientStatus} /> */}
          <div className="profile-inline-editable">
            <MainAddictionRibon
              mainAddiction={clientData.primaryAddiction}
              addictionOther={clientData.addictionOther}
              onClick={handleOpenAddictionModal}
            />
            {openPrimaryAddictionModal && (
              <div className="profile-inline-editor">
                <span className="profile-inline-editor-kicker">Primary addiction</span>
                <DropDownComponent
                  api="addictions"
                  value={newClientAddiction}
                  onChange={handleClientAddictionChange}
                  title="Primary addiction"
                />
                <div className="profile-inline-editor-actions">
                  <Button size="small" onClick={handleCloseAddictionModal}>Cancel</Button>
                  <Button size="small" variant="contained" onClick={handleUpdatePrimaryAddiction} disabled={isLoadingUpdateAddiction}>
                    {isLoadingUpdateAddiction ? "Updating..." : "Save"}
                  </Button>
                </div>
              </div>
            )}
          </div>
          <InformationRibon
            infoLabel="Admission Date"
            labelContent={
              clientData.dateOfAdmission
                ? formatDate(clientData.dateOfAdmission)
                : "No admission date yet"
            }
          />

          <InformationRibon
            infoLabel="Intended duration of stay "
            labelContent={
              clientData.durationOfStay
                ? clientData.durationOfStay
                : "No duration of stay yet"
            }
          />
          {clientData.AggressionControlPolicyOk === true &&
          clientData.ClientRightsOk === true &&
          clientData.ConfidentialityPolicysOk === true &&
          clientData.GeneralLiabilityOk === true &&
          clientData.InformedConsentOk === true &&
          clientData.PsychiatristServicesOk === true ? (
            <CheckRibon check={true} labelContent="Mandatory forms" />
          ) : (
            <CheckRibon labelContent="Mandatory forms" />
          )}
        </div>
        <div className="tab-content">
          <ClientProfilTab clientId={clientData.id} {...clientData} />
        </div>
      </div>
      <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="modal-image"
        aria-describedby="image-full-size"
      >
        <div
          onClick={handleCloseModal}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "100%",
            position: "absolute",
            top: 0,
            left: 0,
            backgroundColor: "rgba(0, 0, 0, 0.2)",
          }}
        >
          <img
            src={clientData.profilePicture}
            alt=""
            style={{
              maxWidth: "90%",
              maxHeight: "90%",
              objectFit: "contain",
            }}
          />
        </div>
      </Modal>
    </div>
  );
}
